export default "__VITE_ASSET__Bhc4pssl__"